//import { combineReducers } from 'redux-immutable';
import { mergeReducers } from 'redux-merge-immutable-reducers';
import { handleActions } from 'redux-actions';
import { Map } from 'immutable';
import coreHotels from '@synergycms_core/store/hotels/hotels';
import actions from '../actions';

//REDUCERS
const hotelsActions = actions.hotels;
const hotels = handleActions(
  {
    [hotelsActions.getAsync.toString()]: (hotels, { payload }) => {
      payload.forEach((hotel, hotelId) => {
        hotels = hotels.set(hotelId, hotels.get(hotelId, Map()).merge(hotel));
      });

      return hotels;
    },
    [hotelsActions.setLastQueryParams.toString()]: (hotels, { payload }) => {
      const params = hotels.getIn([payload.get("hotelId"),"params"], Map());

      return hotels.setIn(
        [payload.get("hotelId"),"params"],
        params.merge(payload));
    }
  },
  Map()
);

//REDUCERS
export default mergeReducers(hotels, coreHotels);
